
import React, { useMemo } from 'react';
import { Bike } from 'lucide-react';
import { supabaseUrl } from '@/integrations/supabase/client';
import { useIsMobile } from '@/hooks/use-mobile';
import { getStorageUrl } from '@/utils/storageUtils';

interface BikeImageProps {
  model: string;
  photoUrl?: string;
}

export const BikeImage: React.FC<BikeImageProps> = ({ model, photoUrl }) => {
  const isMobile = useIsMobile();
  
  // Определяем изображение в зависимости от модели
  const imageUrl = useMemo(() => {
    // Сначала проверяем, есть ли конкретная модель, для которой нужно показать особое изображение
    if (model?.toLowerCase().includes('w33')) {
      const url = 'https://urwzhudyitjovstzqfdj.supabase.co/storage/v1/object/public/pics//W33.png';
      return getStorageUrl(url);
    } else if (model?.toLowerCase().includes('w21')) {
      const url = 'https://urwzhudyitjovstzqfdj.supabase.co/storage/v1/object/public/pics//w21.png';
      return getStorageUrl(url);
    } else if (photoUrl) {
      // Если у нас есть photoUrl, используем его
      const fullUrl = photoUrl.startsWith('http') 
        ? photoUrl 
        : `${supabaseUrl}/storage/v1/object/public/${photoUrl}`;
      return getStorageUrl(fullUrl);
    } else {
      // Для всех остальных моделей используем указанное фото
      const url = 'https://urwzhudyitjovstzqfdj.supabase.co/storage/v1/object/public/pics//W33.png';
      return getStorageUrl(url);
    }
  }, [model, photoUrl]);

  console.log('BikeImage - модель:', model);
  console.log('BikeImage - определенный URL:', imageUrl);
  console.log('BikeImage - isMobile:', isMobile);

  // Добавляем состояние для отслеживания ошибок загрузки изображения
  const [imageLoadError, setImageLoadError] = React.useState(false);

  // Функция для обработки ошибки загрузки изображения
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.error('Ошибка загрузки изображения:', imageUrl);
    setImageLoadError(true);
    e.currentTarget.style.display = 'none'; // скрываем сломанное изображение
  };

  return (
    <div className={`relative overflow-hidden rounded-lg border bg-background ${isMobile ? 'h-36' : 'h-40'} flex items-center justify-center`}>
      {imageUrl && !imageLoadError ? (
        <img 
          src={imageUrl} 
          alt={`Велосипед ${model}`} 
          className={`object-contain w-full ${isMobile ? 'h-32 py-1' : 'h-36'}`}
          onError={handleImageError}
        />
      ) : (
        <div className="flex flex-col items-center justify-center">
          <Bike size={isMobile ? 48 : 64} className="text-muted-foreground" />
          <p className="text-sm text-muted-foreground mt-2">{model}</p>
        </div>
      )}
    </div>
  );
};
